import { cva as a } from "../../modules/index.es4.js";
const x = a(
  "relative flex shrink-0 overflow-hidden rounded-full",
  {
    variants: {
      size: {
        xs: "h-[28px] w-[28px]",
        sm: "h-[36px] w-[36px]",
        md: "h-[48px] w-[48px]",
        lg: "h-[56px] w-[56px]"
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
);
export {
  x as avatarVariant
};
//# sourceMappingURL=Avatar.styles.es.js.map
